import { DropdownButton, MenuItem } from "react-bootstrap";
import Loader from "./Loader";

type Props = {
  children?: React.ReactNode;
  onOpen?: $TSFixMeFunction;
  isLoading?: boolean;
};

export function ItemMenu({ children, onOpen, isLoading }: Props) {
  return (
    <div className="list-item-menu">
      <DropdownButton
        onClick={onOpen}
        bsStyle="default"
        title="..."
        noCaret
        id="dropdown-menu"
        data-testid="dropdown-menu-button"
        pullRight
      >
        {children}
        <MenuItem className="close-item">
          <span className="icon icon-eh-show-less" />
        </MenuItem>
        <Loader id="item-menu-loader" loading={isLoading} withText={false} />
      </DropdownButton>
    </div>
  );
}

export default ItemMenu;
